var exports = {
  "Zd": "DateOfBirthGate.module__form___T25nbU",
  "DD": "DateOfBirthGate.module__title___T25nbU",
  "h_": "DateOfBirthGate.module__description___T25nbU",
  "qr": "DateOfBirthGate.module__footer___T25nbU",
};

module.exports = exports;
